export const INIT_STORE = 'INIT_STORE';
export const SET_LAST_TENANT = 'SET_LAST_TENANT';
export const SET_TENANT = 'SET_TENANT';
export const SET_USER = 'SET_USER';
export const SET_CUR_ORDER = 'SET_CUR_ORDER';
export const SET_CUR_ORDER_ITEM = 'SET_CUR_ORDER_ITEM';
export const SET_SPLIT_RECEIPT = 'SET_SPLIT_RECEIPT';
export const SET_CUR_UNPAID_ORDERS = 'SET_CUR_UNPAID_ORDERS';
export const SET_PAUSED_ORDER = 'SET_PAUSED_ORDER';
export const SET_CUR_TABLE = 'SET_CUR_TABLE';
export const SET_CUR_GUEST = 'SET_CUR_GUEST';
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_PRINT_CONFIG = 'SET_PRINT_CONFIG';
export const SET_IS_ONLINE = 'SET_IS_ONLINE';
export const SET_LOCAL_CONNECTION = 'SET_LOCAL_CONNECTION';
export const SET_DEVICE = 'SET_DEVICE';
export const SET_SYNC_IN_PROGRESS = 'SET_SYNC_IN_PROGRESS';
export const SET_SYNC_OPTIONS = 'SET_SYNC_OPTIONS';
export const SET_WORKING_DAYS = 'SET_WORKING_DAYS';
export const SET_UPDATE_PENDING = 'SET_UPDATE_PENDING';
export const SET_IMPERSONATE = 'SET_IMPERSONATE';
export const SET_INITIALIZED = 'SET_INITIALIZED';
export const SET_TRAINING_MODE = 'SET_TRAINING_MODE';
export const SET_TABLE_MODE = 'SET_TABLE_MODE';
export const SET_TABLE_PERMISSIONS = 'SET_TABLE_PERMISSIONS';
export const SET_ACTIVE_PRICELIST = 'SET_ACTIVE_PRICELIST';
export const SET_MODULES = 'SET_MODULES';
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const SET_PENDING_CARD_PAYMENT = 'SET_PENDING_CARD_PAYMENT';
export const SET_KDS_SETTINGS = 'SET_KDS_SETTINGS';
export const SET_ACTIVE_SECTOR = 'SET_ACTIVE_SECTOR';
